module.exports = __webpack_public_path__ + "img/energy-efficiency.648bf61c.png";